import React from "react";
import {AddTransDialog} from "@/dialog/AddTransDialog";
import {DialogParams, useDialog} from "@/dialog/DialogContext";
import {EditTransDialog} from "@/dialog/EditTransDialog";
import {AddTransLimitDialog} from "@/dialog/AddTransLimitDialog";
import {EditTransLimitDialog} from "@/dialog/EditTransLimitDialog";

export function GlobalDialogs() {
    const dialog = useDialog();

    const dialogType = dialog.dialogType;

    if (!dialogType) {
        return null; // No dialog is open
    } else if (dialogType === 'addTrans') {
        const params = dialog.dialogParams as DialogParams['addTrans'];
        return <AddTransDialog handleClose={dialog.closeDialog} {...params}/>
    } else if (dialogType === 'editTrans') {
        const params = dialog.dialogParams as DialogParams['editTrans'];
        return <EditTransDialog transId={params.transId} handleClose={dialog.closeDialog}/>
    } else if (dialogType === 'addTransLimit') {
        const params = dialog.dialogParams as DialogParams['addTransLimit'];
        return <AddTransLimitDialog accountId={params.accountId} applyDate={params.applyDate}
                                    handleClose={dialog.closeDialog}/>
    } else if (dialogType === 'editTransLimit') {
        const params = dialog.dialogParams as DialogParams['editTransLimit'];
        return <EditTransLimitDialog transLimitId={params.transLimitId} handleClose={dialog.closeDialog}/>
    } else {
        return null;
    }
}
